// Add click event listener to button
const container = document.querySelector(
  ".collection-hero__description-container"
);
const collapsed = container.querySelector(".description-collapsed");
const expanded = container.querySelector(".description-expanded");
const showButton = container.querySelector(".description-show");
const hideButton = container.querySelector(".description-hide");

hideButton.addEventListener("click", () => {
  collapsed.style.display = "block";
  expanded.style.display = "none";
});

showButton.addEventListener("click", () => {
  collapsed.style.display = "none";
  expanded.style.display = "block";
});
